import * as React from 'react';

import * as _ from 'lodash';
import IOwner from 'src/models/IOwner';
// import AddressUtil from 'src/util/Address';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { ManageDeviationsPage } from './ManageDeviationsDialog';
import OwnerUtil from 'src/util/OwnerUtil';

export interface IManageDeviationsLandingDialogProps {
    changePage: (page: ManageDeviationsPage) => void;
}

export type IManageDeviationsLandingStateProps = {
    ownerDeviations: Array<IOwner>;
    page: ManageDeviationsPage;
};

type IManageDeviationsLandingDialogPageProps = IManageDeviationsLandingDialogProps & IManageDeviationsLandingStateProps;

class ManageDeviationsLanding extends React.Component<IManageDeviationsLandingDialogPageProps> {
    constructor(props: IManageDeviationsLandingDialogPageProps) {
        super(props);
    }

    ownerName = (owner: IOwner) => {
        let name = undefined;
        if (owner) {
            const mappedOwner = OwnerUtil.MapOwner(owner);
            name = mappedOwner ? mappedOwner.ownerName() : 'N/A';
        }
        return name;
    };

    primaryDeviations = () => {
        return (
            <>
                {this.props.ownerDeviations
                    ?.filter((x) => x.isPrimaryDeviation)
                    .map((deviation: IOwner, index: number) => {
                        return (
                            <div key={`primary ${index}`}>
                                <div className="owner-detail-info">
                                    <div>
                                        <label>
                                            <span className="owner-detail-info-name">{this.ownerName(deviation)}</span>
                                        </label>
                                    </div>
                                    <div className="owner-detail-info-address">
                                        <div className="lh-half-width">{deviation?.address?.addressLine1}</div>
                                        <div className="lh-fifth-width">{deviation?.address?.city}</div>
                                        <div className="lh-fifth-width">{deviation?.address?.state?.name}</div>
                                        <div className="lh-tenth-width">{deviation?.address?.zipCode}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </>
        );
    };

    secondaryDeviations = () => {
        return (
            <>
                {this.props.ownerDeviations
                    ?.filter((x) => !x.isPrimaryDeviation)
                    .map((deviation: IOwner, index: number) => {
                        return (
                            <div key={`secondary ${index}`}>
                                <div className="owner-detail-info">
                                    <div>
                                        <label>
                                            <span className="owner-detail-info-name">{this.ownerName(deviation)}</span>
                                        </label>
                                    </div>
                                    <div className="owner-detail-info-address">
                                        <div className="lh-half-width">{deviation?.address?.addressLine1}</div>
                                        <div className="lh-fifth-width">{deviation?.address?.city}</div>
                                        <div className="lh-fifth-width">{deviation?.address?.state?.name}</div>
                                        <div className="lh-tenth-width">{deviation?.address?.zipCode}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </>
        );
    };

    public render() {
        return (
            <div>
                {this.props.page === ManageDeviationsPage.Menu && (
                    <div style={{ width: '100rem' }}>
                        <div>
                            <span style={{ fontSize: 'large', fontWeight: 'bold' }}>Primary Deviation</span>
                        </div>
                        {this.primaryDeviations()}
                        <div className="mt-2">
                            <span style={{ fontSize: 'large', fontWeight: 'bold' }}>Secondary Deviations</span>
                        </div>
                        <div style={{ overflowY: 'auto', height: '40rem' }}>{this.secondaryDeviations()}</div>
                        <div style={{ marginTop: '2rem' }}>
                            <Button text="Merge Deviations" onClick={() => this.props.changePage(ManageDeviationsPage.TransferPage)} />
                            <Button
                                text="Change Primary"
                                className="ml-1"
                                onClick={() => this.props.changePage(ManageDeviationsPage.ChangePrimary)}
                            />
                            <Button
                                text="Separate Deviations"
                                className="ml-1"
                                onClick={() => this.props.changePage(ManageDeviationsPage.SeparateDeviation)}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ManageDeviationsLanding;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ManageDeviationsLanding.tsx